import { render, staticRenderFns } from "./ProtocolDetails.vue?vue&type=template&id=ad50ba3a"
import script from "./ProtocolDetails.vue?vue&type=script&lang=js"
export * from "./ProtocolDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports